import { HSLColor } from '@yola/yola-palette-generator';
import parseHslColorString from 'src/js/modules/website-design/helpers/parse-hsl-color-string';
import isLightColorType from './is-light-color-type';

const isLightColorString = (hslColorString) => {
  const hslColor = new HSLColor(...Object.values(parseHslColorString(hslColorString)));
  return isLightColorType(hslColor);
};

export default isLightColorString;
